import { render } from "@testing-library/react"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SecondaryButton from "Components/atoms/buttons/secondary-button"
import Breadcrumb from 'Components/organisms/breadcrumb';
import LoadingState from 'Components/organisms/loading-state';
import DocumentCard from "Components/molecule/cards/document-card"
import GenerateDocumentForm from "Components/organisms/forms/generate-docuement-form"
import Doc from "models/document"
import Value from "models/field"
import { FormEvent, ReactNode, useMemo } from "react"
import { Container } from "reactstrap"
import Field from "models/field";
import FormProps from "data/forms";
import { GEN_DOC_STATUS } from "models/gen-doc-status";
import ActionButton from "Components/atoms/buttons/action-button";
import ApproveButton from "Components/atoms/buttons/approve-button";
import RejectButton from "Components/atoms/buttons/reject-button";
import Modal from "Components/molecule/modal";
import RejectDocumentForm from "Components/organisms/forms/reject-document-form";
import RejectDocumentFormFields from "Components/organisms/forms/reject-document-form/types";
import GeneratedDoc from "models/generated-doc";
import ApproveOnBehalfForm from "Components/organisms/forms/approve-on-behalf-form";
import Employee from "models/employee";
import AreYouSureButtons from "Components/molecule/are-you-sure-buttons";
import { HelpIcon, CheckCircleIcon, CloseCircleIcon, DownloadIcon } from "Components/atoms/icons";

interface GenerateDocumentsTemplateProps extends FormProps<RejectDocumentFormFields> {
    doc?: Doc
    genDoc?: GeneratedDoc
    fields: Field[]
    processingDocument: boolean;
    viewingDocument: boolean;
    showRejectModal: boolean
    showApproveOnBehalfModal: boolean
    showApproveModal: boolean
    generateDocError: string | null;
    docStatus?: GEN_DOC_STATUS
    approvers?: Employee[]
    approvalBlockedReason?: string | null
    renderInput: (_field: Value) => ReactNode
    recruitFormSection: ReactNode
    handleViewDocument: (_document: Doc) => void
    handleDrafDocument?: () => any
    handleSubmitDocument?: () => any
    handleDownloadDocument?: () => any
    handleApproveDocument?: () => any
    handleShowRejectModal?: () => any
    handleHideRejectModal?: () => any
    handleShowCandidateRejectModal?: () => any
    handleHideCandidateRejectModal?: () => any
    showCandidateRejectModal: boolean
    candidateRejectForm: FormProps<RejectDocumentFormFields>
    handleOpenHelpDocument?: () => any,
    handleApproveOnBehalf?: (empployees: string[]) => Promise<void>,
    handleShowApproveOnBehalf?: () => any,
    handleHideApproveOnBehalf?: () => any,
    handleShowApproveModal?: () => any,
    handleHideApproveModal?: () => any,
    handleBack: () => any
}


const GenerateDocumentsTemplate = ({
    doc,
    genDoc,
    fields,
    processingDocument,
    viewingDocument,
    showRejectModal,
    showApproveOnBehalfModal,
    showApproveModal,
    generateDocError,
    docStatus,
    approvers,
    approvalBlockedReason,
    renderInput,
    recruitFormSection,
    handleViewDocument,
    handleBack,
    handleDrafDocument,
    handleSubmitDocument,
    handleDownloadDocument,
    handleOpenHelpDocument,
    handleHideRejectModal,
    handleShowCandidateRejectModal,
    handleHideCandidateRejectModal,
    showCandidateRejectModal,
    candidateRejectForm,
    handleApproveDocument,
    handleShowRejectModal,
    handleApproveOnBehalf,
    handleShowApproveOnBehalf,
    handleHideApproveOnBehalf,
    handleHideApproveModal,
    handleShowApproveModal,
    ...props
}: GenerateDocumentsTemplateProps) => {

    return <div className="page-content">
        <Container fluid>
            <Breadcrumb
                title="Human Resoures"
                breadcrumbItem="Document Generator"
                actions={<>
                    {
                        handleOpenHelpDocument &&
                        <ActionButton
                            onClick={() => handleOpenHelpDocument()}
                        >
                            Help <HelpIcon />
                        </ActionButton>
                    }

                    <ActionButton onClick={() => handleBack()}>
                        Back
                    </ActionButton>

                </>}
            />

            {doc ?
                <>
                    <div className="section-container">
                        <div>
                            <h4>Employee Document Generator {docStatus ? `(${docStatus})` : ''}</h4>
                            <h6>Please fill out the following fields and click generate.</h6>
                        </div>
                        {recruitFormSection}
                        <GenerateDocumentForm
                            fields={fields}
                            renderInput={renderInput}
                        />
                    </div>
                    <div className="document-and-actions-container section-container">
                        <DocumentCard document={doc} handleView={handleViewDocument} loading={viewingDocument} />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div className="generate-documents-button-container">
                                {handleDrafDocument && <PrimaryButton disabled={processingDocument} onClick={handleDrafDocument}>Save Draft</PrimaryButton>}
                                {handleSubmitDocument && <PrimaryButton disabled={processingDocument} onClick={handleSubmitDocument}>Submit</PrimaryButton>}
                                {handleDownloadDocument && <PrimaryButton disabled={processingDocument} onClick={handleDownloadDocument}>Download Final <DownloadIcon /></PrimaryButton>}
                                {handleShowApproveModal && <ApproveButton disabled={processingDocument} onClick={handleShowApproveModal}>{processingDocument ? <>Approving... <CheckCircleIcon /></> : <>Approve <CheckCircleIcon /></>}</ApproveButton>}
                                {handleShowRejectModal && !handleShowApproveModal && <ApproveButton title={approvalBlockedReason ?? undefined} disabled={true} >Approve <CheckCircleIcon /></ApproveButton>}
                                {handleShowRejectModal && <RejectButton onClick={handleShowRejectModal} disabled={processingDocument}>{processingDocument ? <>Rejecting... <CloseCircleIcon /></> : <>Reject <CloseCircleIcon /></>}</RejectButton>}
                                {handleShowCandidateRejectModal && <RejectButton onClick={handleShowCandidateRejectModal} disabled={processingDocument}>{processingDocument ? <>Rejecting... <CloseCircleIcon /></> : <>Candidate Reject <CloseCircleIcon /></>}</RejectButton>}
                                {handleShowApproveOnBehalf && <PrimaryButton style={{ backgroundColor: 'var(--bs-blue)' }} disabled={processingDocument} onClick={handleShowApproveOnBehalf}>Approve On Behalf</PrimaryButton>}
                            </div>
                            {generateDocError && <span>{generateDocError}</span>}
                        </div>
                    </div>
                </>
                :
                <LoadingState title="Loading Document" subtitle="Please wait while we fetch the document." />

            }
            {
                handleHideRejectModal &&
                <Modal
                    isOpen={showRejectModal}
                    onClose={handleHideRejectModal}
                    title={"Reject Document"}
                >
                    <RejectDocumentForm {...props} />
                </Modal>
            }

            {
                handleHideCandidateRejectModal &&
                <Modal
                    isOpen={showCandidateRejectModal}
                    onClose={handleHideCandidateRejectModal}
                    title={"Reject Document By Candidate"}
                >
                    <RejectDocumentForm {...candidateRejectForm} />
                </Modal>
            }

            {
                handleApproveDocument && handleHideApproveModal &&
                <Modal
                    isOpen={showApproveModal}
                    onClose={handleHideApproveModal}
                    title={"Accept Document"}
                >
                    <AreYouSureButtons
                        handleAccept={handleApproveDocument}
                        handleDecline={handleHideApproveModal}
                        acceptText={"Approve Document"}
                        declineText={"Cancel"}
                    />
                </Modal>
            }

            {
                handleHideApproveOnBehalf && handleApproveOnBehalf && approvers &&
                <Modal
                    isOpen={showApproveOnBehalfModal}
                    onClose={handleHideApproveOnBehalf}
                    title={"Approve on behalf"}
                >
                    <ApproveOnBehalfForm
                        employees={approvers}
                        onSubmit={handleApproveOnBehalf}
                        onCancel={handleHideApproveOnBehalf}
                    />
                </Modal>
            }
        </Container>
    </div>
}


export default GenerateDocumentsTemplate